import React from 'react';
import { ArrowLeft, Eye, Shield } from 'lucide-react';
import { Button } from '../ui/Button';
interface ViewingLearnerBannerProps {
  learnerName: string;
  portalName: string;
  onReturn: () => void;
}
export function ViewingLearnerBanner({
  learnerName,
  portalName,
  onReturn
}: ViewingLearnerBannerProps) {
  const isAdmin = portalName === 'Beheer';
  return <div className={`${isAdmin ? 'bg-slate-800' : 'bg-indigo-600'} text-white px-4 py-3 shadow-md relative z-50`} data-id="element-1855">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3" data-id="element-1856">
        <div className="flex items-center gap-2" data-id="element-1857">
          {isAdmin ? <Shield className="w-5 h-5 text-slate-300" data-id="element-1858" /> : <Eye className="w-5 h-5 text-indigo-200" data-id="element-1859" />}
          <span className="font-medium" data-id="element-1860">
            {isAdmin ? 'Admin: ' : ''}Je bekijkt nu het dashboard van{' '}
            <strong className="font-black" data-id="element-1861">{learnerName}</strong>
          </span>
        </div>
        <Button variant="secondary" size="sm" onClick={onReturn} className={`bg-white ${isAdmin ? 'text-slate-800 hover:bg-slate-100' : 'text-indigo-700 hover:bg-indigo-50'} border-none whitespace-nowrap`} data-id="element-1862">
          <ArrowLeft className="w-4 h-4 mr-2" data-id="element-1863" />
          Terug naar {portalName}
        </Button>
      </div>
    </div>;
}